<template>
  <div class="lots-list tab-table p-2">
    <LotsTable :hide-actions="hideActions" :exclude-columns="['date', 'sale_no', 'new_low', 'new_high', 'new_reserve', 'new_start_price', 'proposal_sent_at', 'proposal_sent_by', 'proposal_confirmed_at', 'proposal_confirmed_by']"
               :exclude-search-fields="['start_date', 'end_date']" enable-frontend-export/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import LotsTable from "../../../lots/LotsTable";
  import _ from 'lodash';
  import {
    ACTION_ARCHIVE_LOT, ACTION_MARK_UNSOLD,
    ACTION_PUBLISH_LOT,
    ACTION_REVERT_TO_COMPLETED_LOT,
    ACTION_SYNC_LOTS
  } from "../../../constants";

  const {mapState} = createNamespacedHelpers('sales');
  const {mapActions: lotsMapActions} = createNamespacedHelpers('lots');

  export default {
    name: "LotsList",
    components: {LotsTable},
    data() {
      return {
        hideActions: [
          ACTION_PUBLISH_LOT,
          ACTION_ARCHIVE_LOT,
          ACTION_REVERT_TO_COMPLETED_LOT,
          ACTION_SYNC_LOTS,
          ACTION_MARK_UNSOLD
        ],
      }
    },
    computed: {
      ...mapState({sale: state => state.view.currentSale})
    },
    methods: {
      ...lotsMapActions(['updateTableSource']),
      async updateSource() {
        return await this.updateTableSource({
          source: 'sale',
          extraFilters: {auction_uuid: this.sale.uuid},
          sale: _.cloneDeep(this.sale)
        })
      }
    },
    watch: {
      async sale() {
        await this.updateSource()
      }
    },
    async beforeMount() {
      await this.updateSource()
    }
  }
</script>

<style lang="scss" scoped>
</style>
